export default __webpack_public_path__ + "static/media/Service1.01f027c9.jpg";